var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 500h1024v-500h-1024v500z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.466 -429.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1166 0 0 -1.1166 -103.49 863.09)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(375.72 120.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c8.134 0 14.73 6.596 14.73 14.73v237.43c0 8.137-6.596 14.731-14.73 14.731h-237.43c-8.137 0-14.73-6.594-14.73-14.731v-237.43c0-8.134 6.593-14.73 14.73-14.73h237.43z",
    fill: "#3b5998"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.7 120.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v103.36h34.693l5.194 40.28h-39.887v25.717c0 11.662 3.238 19.609 19.962 19.609l21.33 0.01v36.026c-3.69 0.49-16.351 1.587-31.081 1.587-30.753 0-51.806-18.771-51.806-53.244v-29.705h-34.781v-40.28h34.781v-103.36h41.595z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f9cdd156b2de4a0ae5b3013023759a6e.svg";
export { ForwardRef as ReactComponent };